import styled from 'styled-components';

interface ShareLinkProps {
    title: string;
    href?: string;
    handleOnClick: () => void;
    icon: string;
}

const ShareLink = ({ title, href, handleOnClick, icon }: ShareLinkProps) => {
    return (
        <a title={title} href={href} target="_blank" onClick={handleOnClick}>
            <ShareLinkIcon className={icon} />
        </a>
    );
};

export default ShareLink;

interface IconProps {
    isSoar?: boolean;
}

export const ShareLinkIcon = styled.i<IconProps>`
    color: white;
    font-size: 18px;
    margin: 0px 0px 0px 16px;
    pointer-events: all;
    cursor: pointer;

    &:hover {
        color: #eed926;
    }
`;
